import React, {useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import DesktopHeader from "../../desktopHeader";
import MaterialsAgentTutorial from "../../tutorials/materialsAgentTutorial";
import {getMaterialsWizardItem} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {switchToWizardItem} from "./useChangeWizardStepRoute";
import MaterialsWizardBody from "./materialsWizardBody";
import MaterialsWizardFooterSteps from "./materialsWizardFooterSteps";
import MaterialsWizardFooterButtons from "./materialsWizardFooterButtons";
import store from "../../../store";
import {toggleBathroomVisualizerOpen} from "../../../actions/actionFunctions";
import NavItemPositionModal from "../../visComponents/navigation/navItemPositionModal";
import MaterialsWizardContextProvider from "./MaterialsWizardContextProvider";

const MaterialsWizard = (props) => {

  const {wizardList, wizardActiveItem, match, location, toggleBathroomVisualizerOpen, bvOpened,
    visualizerIsChanging} = props;

  useEffect(() => {
    console.log("wizardActiveItem", wizardActiveItem);
    // setWizardActiveStep(0);
    // setWizardSelectedValues({}, true);
    // console.log("match.params", match.params);
    const wizardItem = getMaterialsWizardItem(wizardList, match.params);
    console.log("wizardItem", wizardItem);
    if (wizardItem && (!wizardActiveItem || (wizardActiveItem.visualizer !== wizardItem.visualizer))
      && window.location.href.includes("materials")) {
      switchToWizardItem(wizardItem, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardList, visualizerIsChanging])

  useEffect(() => {
    setTimeout(() => {
      if (!location || !location.pathname) {
        return
      }
      // console.log("useEffect location.pathname", location.pathname);
      const currentStore = store.getState();
      const {bvOpened} = currentStore.bathroomVisualizerState;  // we need to detect current values
      if (location.pathname.includes("visualizer") && window.location.href.includes("visualizer")) {
        // console.log("useEffect toggleBathroomVisualizerOpen", location.pathname);
        toggleBathroomVisualizerOpen(true);
      } else if (bvOpened) {
        toggleBathroomVisualizerOpen(false);
      }
    }, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);


  if (!wizardActiveItem) {
    return null
  }


  return (
    <MaterialsWizardContextProvider>
      <div className="overlay overlay--white">
        <div className="selection selection--opened">
          <div className="materials">
            <DesktopHeader uploadsAndNotes={false}/>
            <MaterialsWizardBody/>
            <div className="selection-footer">
              <MaterialsWizardFooterSteps wizardItem={wizardActiveItem}/>
              <MaterialsWizardFooterButtons/>
            </div>
          </div>
        </div>
        <MaterialsAgentTutorial/>
        {bvOpened ? null : <NavItemPositionModal isWizard={true}/>}
      </div>
    </MaterialsWizardContextProvider>
  )

};

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {bvOpened} = store.bathroomVisualizerState;
  const {visualizerIsChanging} = store.serverState;
  // const {isSQFTInVisualizer} = store.sqftState;
  // const {isModalFixOpen} = store.sqftModalFixState;

  return {
    bvOpened,
    wizardList,
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    visualizerIsChanging,
    // isSQFTInVisualizer,
    // isModalFixOpen,
  };
};

const mapDispatchToProps = {
  toggleBathroomVisualizerOpen,
  // setWizardActiveItem,
  // setWizardActiveStep,
  // setWizardSelectedValues,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MaterialsWizard)
)
